// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2aRF3","inner":"Footer_inner__2mGJx","nextIcon":"Footer_nextIcon__3UBDf","innerLeft":"Footer_innerLeft__3Tn2X"};